import { AuthorRole } from './AuthorRole'

export default class GrowingAuthor extends AuthorRole {
  maxParticipantsPerArc: number = 25
  maxRunningArcs: number = 1
}
